var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "61",
        height: "60",
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M50.5784 11.0887L38.7834 19.7191H34.8976L23.3863 15.3339L10.3116 23.7779L9.22656 22.0979L23.1519 13.1044L35.2656 17.7191H38.1298L49.3973 9.47461L50.5784 11.0887Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M4.14453 37H15.3945V55H4.14453V37Z", fill: "#E1503C" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M17.6445 27.4375H28.8945V55H17.6445V27.4375Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M44.6445 22.375H55.8945V55H44.6445V22.375Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M31.1445 33.625H42.3945V55H31.1445V33.625Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M13.707 22.9375C13.707 25.1121 11.9442 26.875 9.76953 26.875C7.59491 26.875 5.83203 25.1121 5.83203 22.9375C5.83203 20.7629 7.59491 19 9.76953 19C11.9442 19 13.707 20.7629 13.707 22.9375Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M27.207 14.5C27.207 16.6746 25.4442 18.4375 23.2695 18.4375C21.0949 18.4375 19.332 16.6746 19.332 14.5C19.332 12.3254 21.0949 10.5625 23.2695 10.5625C25.4442 10.5625 27.207 12.3254 27.207 14.5Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M40.707 19C40.707 21.1746 38.9442 22.9375 36.7695 22.9375C34.5949 22.9375 32.832 21.1746 32.832 19C32.832 16.8254 34.5949 15.0625 36.7695 15.0625C38.9442 15.0625 40.707 16.8254 40.707 19Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M53.6445 10.5625C53.6445 12.7371 51.8817 14.5 49.707 14.5C47.5324 14.5 45.7695 12.7371 45.7695 10.5625C45.7695 8.38788 47.5324 6.625 49.707 6.625C51.8817 6.625 53.6445 8.38788 53.6445 10.5625Z",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }